import React, { useEffect, useState } from 'react';

const HeartRateCard: React.FC = () => {
  const [heartRate, setHeartRate] = useState<number>(72);

  useEffect(() => {
    const interval = setInterval(() => {
      // Simulate heart rate changes
      setHeartRate(70 + Math.floor(Math.random() * 10));
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="card heart-rate-card">
      <h3>Heart Rate</h3>
      <p className="heart-rate-value">{heartRate} BPM</p>
    </div>
  );
};

export default HeartRateCard;
